import Skeleton from 'react-loading-skeleton';

import { ArrowRightIcon } from '@heroicons/react/20/solid';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

import useSubscriptionCheckoutUrl from '@/hooks/useSubscriptionCheckoutUrl';

interface InvalidPlanBannerProps {
  onLearnMoreClick: () => void;
  // Optional override for checkout URL (falls back to hook)
  checkoutUrl?: string;
}

export default function InvalidPlanBanner({
  checkoutUrl: providedCheckoutUrl,
  onLearnMoreClick,
}: InvalidPlanBannerProps) {
  const { checkoutUrl: hookCheckoutUrl, isCheckoutUrlReady } =
    useSubscriptionCheckoutUrl();

  // Use provided checkout URL or fall back to hook
  const checkoutUrl = providedCheckoutUrl || hookCheckoutUrl;
  const shouldShowJoinButton =
    Boolean(checkoutUrl) && (providedCheckoutUrl || isCheckoutUrlReady);
  return (
    <div className="rounded-md bg-brand-100 max-w-2xl text-white p-3 md:mt-0 right-0">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <InformationCircleIcon
            className="h-5 w-5 text-brand-900"
            aria-hidden="true"
          />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-brand-900">
            tapt Management Dashboard plan invalid
          </h3>
          <p className="mt-2 text-sm leading-5 text-brand-600">
            You currently do not have an active plan to access the tapt
            Management Dashboard. If you would like access to management
            features, activate your plan below.{' '}
            <button type="button" onClick={onLearnMoreClick}>
              <span className="underline">Learn more</span>
            </button>
          </p>
          {shouldShowJoinButton ? (
            <a
              href={checkoutUrl}
              target="_blank"
              rel="noreferrer"
              className="mt-2 text-sm leading-5 font-medium text-brand-500 flex w-full"
            >
              Join now
              <ArrowRightIcon className="ml-2 w-5 h-5" />
            </a>
          ) : !providedCheckoutUrl && !isCheckoutUrlReady ? (
            <div className="mt-2">
              <Skeleton width={80} height={20} />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
